import { twMerge } from 'tailwind-merge';

import { Skeleton } from '@/components/ui/daisy';

export const COURSE_TRACK_CARD_WIDTH = 'w-72 md:w-68';
export const COURSE_TRACK_ITEM_CLASS_NAME =
  'w-72 md:min-w-68 md:flex-1 md:max-w-80';
export const COURSE_TRACK_ITEM_MIN_HEIGHT = 'min-h-[27.5rem]';

type CourseTrackSkeletonProps = {
  className?: string;
};

export default function CourseTrackSkeleton({
  className,
}: CourseTrackSkeletonProps) {
  return (
    <Skeleton
      className={twMerge(
        'shrink-0 rounded-3xl',
        COURSE_TRACK_ITEM_MIN_HEIGHT,
        COURSE_TRACK_ITEM_CLASS_NAME,
        className,
      )}
    />
  );
}
